import React from 'react';
import Box from '@mui/material/Box';
import './AboutUs.scss';

export default function AboutUs(props) {
  return (
    <Box className={'aboutContainer'}>
      <h3>Museums of Bhutan</h3>
      <p style={{textAlign: 'justify'}}>
        Museums of Bhutan fall under the purview of Museum Division, Department of Culture & Dzongkha Development,
        Ministry of Home Affairs(MoHA). The Museum Division provides for strategic planning, budgeting and monitoring
        museum operations with a focus on continuous improvement of public services and enhancing visitor experience,
        safety and and security of artifacts. The guidelines and technical support we strive to uphold professionalism
        in museum management. Established in 2023 as part of a transformative administrative reform, the Museum Division
        aims to elevate the standard of museum operations and visitor engagement. Currently, three museums operate under
        our guidance:
      </p>
      <ul>
        <li style={{textAlign: 'justify'}}>
          The National Museum of Bhutan locatedin Paro, established in 1968 is Bhutan’s first museum. It is housed in the
          historic Ta-dzong built by La-ngonpa Tenzin Drugdra, the first governor of Paro dating back to the 17th
          century. With a collection of over 3000 artifacts, it showcases Bhutan’s rich material cultural heritage,
          including artifacts dating as early as 3000 BC, reflecting the earliest human settlements in Bhutan.
        </li>
        <li style={{textAlign: 'justify'}}>
          The Royal Heritage Museum in Trongsa is housed in the renovated Ta-dzong built by Chogyal Minjur Tenpa, the
          first Trongsa Penlop in 1652. Established in 2008 the Royal Heritage museum commemorates the ascension of His
          Majesty the Druk Gyalpo Jigme Khesar Namgyal Wangchuck, King of Bhutan on the golden throne and Bhutan’s
          transition into constitutional monarchy.
        </li>
        <li style={{textAlign: 'justify'}}>
          The Textile Museum in Thimphu preserves and promotes Bhutan's traditional woven textiles, symbolizing our
          cultural identity through intricate weaving processes. Established in 2001 under the royal patronage of Her
          Majesty the Gyalyum Sangay Choden Wangchuck, Queen Mother of Bhutan to celebrate Bhutan's rich textile
          heritage.
        </li>
      </ul>
    </Box>
  );
}